import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { ActivatedRoute } from '@angular/router';
import { ContactUs , ContactUsRespons } from './ContactUs';
import * as $ from 'jquery';
import {Globals} from '../globals';
@Component({
  selector: 'app-contactus',
  templateUrl: './contactus.component.html',
  styleUrls: ['./contactus.component.scss']
})
export class ContactusComponent implements OnInit {

  contactForm: FormGroup;
  submitted = false;
  contact: ContactUs;
  contactRespons: ContactUsRespons;
responseAns;
responses;
  constructor(private formBuilder: FormBuilder , private http: HttpClient , private route: ActivatedRoute, public globals: Globals) { }
phone = /^[0-9\+]{1,}[0-9\-]{3,15}$/;
  ngOnInit() {
    $(window).scrollTop(0);
    this.contactForm = this.formBuilder.group({
      name: ['', Validators.required ],
      email: ['', [Validators.required, Validators.email]],
      phone: ['', [Validators.required, Validators.pattern(this.phone)]],
      message: ['', [Validators.required, Validators.minLength(6)]],
  });


  this.http.get<ContactUs>(this.globals.urlMain +'contact').subscribe(data => {
    this.contact = data;


  });
  }

  get f() { return this.contactForm.controls; }

    onSubmit(e) {
      var name = e.target.elements[0].value;
      var email = e.target.elements[1].value;
      var phone = e.target.elements[2].value;
      var text = e.target.elements[3].value;



          this.submitted = true;
          // stop here if form is invalid
          if (this.contactForm.invalid) {
              return;
          } else {

            let httpParams = new HttpParams();
            httpParams = httpParams.append("first_name", name);
            const myheader = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
            let body = new HttpParams();
            body = body.set('name', name);
            body = body.set('email', email);
            body = body.set('phone', phone);
            body = body.set('text', text);

         const req =   this.http.post(this.globals.urlMain +"send-email",body, { headers: myheader}).subscribe( data => {
         this.responseAns = data;
          this.responses = this.responseAns.status;
          if(this.responses == 'success') {
            $('.messageSent').addClass('active');
            $('.contactUs .myContainer .contactForm form > div input, .contactUs .myContainer .contactForm form > div textarea').val()
            setTimeout(()=>{
              $('.messageSent').removeClass('active');
             }, 2000)
        } else {
          $('.messageSentError').addClass('active');
            setTimeout(()=>{
              $('.messageSentError').removeClass('active');
             }, 2000)
        }
         });

        //  $('.messageSent').addClass('active');
        //  setTimeout(()=>{
        //   $('.messageSent').removeClass('active');
        //  }, 2000)
      return false;

          }

    }
    alertMessages() {

    }
}
